/**
 * Extracts and formats benefits from a membership object
 * @param {Object} membership - The membership object containing benefit data
 * @returns {Array} Array of formatted benefits
 */
export function extractMembershipBenefits(membership) {
  if (!membership) {
    return [];
  }

  let benefits = [];

  if (
    (membership.benefitAmount && Number(membership.benefitAmount) > 0) ||
    membership.applicableServiceCategoryIds?.length ||
    membership.applicableServiceIds?.length ||
    membership.applicablePackageIds?.length ||
    membership.applicableProductIds?.length ||
    membership.applicableBrandIds?.length ||
    membership.creditAppliesToAllServices ||
    membership.creditAppliesToAllProducts
  ) {
    benefits.push({
      type: 'credit',
      amount: membership.benefitAmount,
      applicableServiceCategoryIds: membership.applicableServiceCategoryIds,
      applicableServiceIds: membership.applicableServiceIds,
      applicablePackageIds: membership.applicablePackageIds,
      applicableBrandIds: membership.applicableBrandIds,
      applicableProductIds: membership.applicableProductIds,
      creditAppliesToAllServices: membership.creditAppliesToAllServices,
      creditAppliesToAllProducts: membership.creditAppliesToAllProducts,
    });
  }

  const typeMap = {
    MembershipServiceDiscountBenefit: 'service-discount',
    MembershipRetailDiscountBenefit: 'retail-discount',
    MembershipRecurringServiceBenefit: 'recurring-service',
    MembershipCustomBenefit: 'custom',
  };

  membership.benefits?.forEach((benefit) => {
    if (typeMap[benefit.__typename]) {
      benefits.push({
        type: typeMap[benefit.__typename],
        ...benefit,
      });
    }
  });

  return benefits;
}
